export const XHR_BOX_FILTER_STRATEGY_NAME = 'Filter';
export const XHR_BOX_RECENT_STRATEGY_NAME = 'Recent';
